import React from 'react';
import { ReactComponent as RefreshIcon } from '../../assets/refresh.svg';
import axiosInstance from '../../utils/axiosConfig';

const ProfileReset = ({ completedLessons, totalLessons, onReset }) => {
    const isCompleted = completedLessons === totalLessons;

    const handleReset = () => {
        // Спрашиваем подтверждение через встроенный confirm
        const confirmReset = window.confirm("Вы уверены, что хотите сбросить весь прогресс курса? Это действие обнулит ваш прогресс и приведёт к падению в рейтинге.");

        if (confirmReset) {
            // Делаем запрос к API
            axiosInstance.post('/profile/reset')
                .then(response => {
                    if (response.data.success) {
                        alert('Прогресс успешно сброшен!');

                        // Вызываем функцию обновления данных, если она передана
                        if (onReset && typeof onReset === 'function') {
                            onReset();
                        }

                        // Перезагружаем страницу
                        window.location.reload();
                    } else {
                        alert('Не удалось сбросить прогресс');
                    }
                })
                .catch(error => {
                    console.error('Ошибка при сбросе прогресса:', error);
                    alert('Произошла ошибка при сбросе прогресса');
                });
        }
    };

    return (
        <div className="profile-reset-container">
            <div className="reset-background">
                <div className="background-rect"></div>
                <svg className="corner top-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 2H13.6364L2 12.2655V31" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner top-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2H36.3636L48 12.2655V31" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-left" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34 48H13.6364L2 37.7345V19" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
                <svg className="corner bottom-right" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 48H36.3636L48 37.7345V19" strokeWidth="3" strokeMiterlimit="10" />
                </svg>
            </div>
            <div className="reset-content">
                <div className="reset-header">
                    <h2 className="reset-title">
                        {isCompleted ? '🜚 Поздравляем, курс пройден!' : '⌬ Вы ещё на пути к финалу'}
                    </h2>
                </div>
                <p className="reset-description">
                    {isCompleted
                        ? 'желаете повторить материалы?'
                        : 'Завершите все уроки, чтобы получить доступ к повторному прохождению'
                    }
                </p>
                <button
                    className={`reset-button ${!isCompleted ? 'disabled' : ''}`}
                    disabled={!isCompleted}
                    onClick={handleReset}
                >
                    <div className="button-background">
                        {/* Верхняя линия */}
                        <div className="dash-line top"></div>
                        {/* Нижняя линия */}
                        <div className="dash-line bottom"></div>

                        {/* Левый верхний угол */}
                        <div className="corner top-left">
                            <div className="vertical"></div>
                            <div className="horizontal"></div>
                        </div>

                        {/* Правый верхний угол */}
                        <div className="corner top-right">
                            <div className="vertical"></div>
                            <div className="horizontal"></div>
                        </div>

                        {/* Левый нижний угол */}
                        <div className="corner bottom-left">
                            <div className="vertical"></div>
                            <div className="horizontal"></div>
                        </div>

                        {/* Правый нижний угол */}
                        <div className="corner bottom-right">
                            <div className="vertical"></div>
                            <div className="horizontal"></div>
                        </div>
                    </div>
                    <RefreshIcon className="button-icon" />
                    <span className="button-text">Пройти курс заново</span>
                </button>
            </div>
        </div>
    );
};

export default ProfileReset; 